module.exports = __webpack_public_path__ + "img/logo-full-greenpay.2e964554.png";